import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "relative mt-1" };
const _hoisted_2 = { class: "flex flex-row flex-grow" };
const _hoisted_3 = {
    key: 0,
    class: "px-2"
};
const _hoisted_4 = { class: "truncate px-1 font-medium" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-chevron-down" }, null, -1);
const _hoisted_6 = { key: 0 };
const _hoisted_7 = {
    key: 0,
    class: "absolute inset-y-0 right-0 flex items-center pr-3 text-amber-600"
};
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-check small" }, null, -1);
const _hoisted_9 = [
    _hoisted_8
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ListboxButton = _resolveComponent("ListboxButton");
    const _component_ListboxOption = _resolveComponent("ListboxOption");
    const _component_ListboxOptions = _resolveComponent("ListboxOptions");
    const _component_Listbox = _resolveComponent("Listbox");
    return (_openBlock(), _createBlock(_component_Listbox, {
        modelValue: _ctx.selectedProp,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedProp) = $event))
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_ListboxButton, {
                    disabled: _ctx.disabled,
                    class: _normalizeClass([{ 'bg-gray-200 border-none': _ctx.disabled }, "relative flex items-center w-full border m-0 py-2 text-left bg-white rounded cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 border-gray-200 sm:text-sm"])
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            (_ctx.$slots.icon)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _renderSlot(_ctx.$slots, "icon", { selected: _ctx.selectedProp })
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.translate(`${_ctx.translation}.${_ctx.getSelectedItem(_ctx.selectedProp)}`, _ctx.getSelectedItem(_ctx.selectedProp))), 1)
                        ]),
                        _hoisted_5
                    ]),
                    _: 3
                }, 8, ["disabled", "class"]),
                _createVNode(_Transition, {
                    "leave-active-class": "transition duration-100 ease-in",
                    "leave-from-class": "opacity-100",
                    "leave-to-class": "opacity-0"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_ListboxOptions, { class: "absolute w-full py-1 mt-1 z-10 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputs, (input, index) => {
                                    return (_openBlock(), _createBlock(_component_ListboxOption, {
                                        key: input + index,
                                        value: input,
                                        as: "template"
                                    }, {
                                        default: _withCtx(({ active, selected }) => [
                                            _createElementVNode("li", {
                                                class: _normalizeClass(["cursor-pointer hover:bg-gray-200", [active ? 'text-amber-900 bg-amber-100' : 'text-gray-900', 'cursor-default select-none relative pl-4']])
                                            }, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["block truncate", {
                                                            'font-medium': selected,
                                                            'font-normal': !selected,
                                                            'pl-4': input.deepLevel === 1,
                                                            'pl-8': input.deepLevel === 2,
                                                            'pl-12': input.deepLevel === 3,
                                                            'pl-16': input.deepLevel >= 4,
                                                        }])
                                                }, [
                                                    (input.deepLevel)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "- "))
                                                        : _createCommentVNode("", true),
                                                    _createTextVNode(_toDisplayString(_ctx.translate(`${_ctx.translation}.${_ctx.getSelectedItem(input)}`, _ctx.getSelectedItem(input))), 1)
                                                ], 2),
                                                selected
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
                                                    : _createCommentVNode("", true)
                                            ], 2)
                                        ]),
                                        _: 2
                                    }, 1032, ["value"]));
                                }), 128))
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 3
    }, 8, ["modelValue"]));
}
